<template>
  <div
    class="subpixel-antialiased font-mayday text-base text-gray-9 selection:bg-primary/10 w-full h-full"
    :class="{ alt: isAlt }"
    :style="[colorsStyle]"
  >
    <MasterView>
      <router-view>
        <template v-slot="{ Component, route }">
          <Transition :name="transitionName">
            <!-- Use route.path here instead of route.fullPath, because modalContentId query or other refresh the application -->
            <component :is="Component" :key="route.path" />
          </Transition>
        </template>
      </router-view>
    </MasterView>
    <Flowy />
    <Zoomer />
    <NotificationsInApp />
  </div>
</template>

<script setup lang="ts">
import type { Pinia } from 'pinia'
import { inject } from 'vue'
import { useAdminStore } from '@getmayday/vue-modules'
import MasterView from '@commons/components/Layout/MasterView.vue'
import Zoomer from '@commons/components/Layout/LightBox/Zoomer.vue'
import Flowy from '@commons/components/Layout/LightBox/Flowy.vue'
import { useHelpdeskStore } from '@commons/stores/helpdesk'
import { COLORS } from '@commons/theme'
import NotificationsInApp from '@commons/components/Layout/NotificationsInApp.vue'
import WebsocketHandler from '@commons/services/websocket'

const pinia = inject('pinia') as Pinia

const router = useRouter()

const adminStore = useAdminStore(pinia)

const configStore = useConfigStore()
const iAdvizeStore = useHelpdeskStore()
const { transitionName, locale } = storeToRefs(configStore)
const { idzPrimaryColor, idzSecondaryColor } = storeToRefs(adminStore)

const websocketHandler = new WebsocketHandler()

const { loggedIn, companyColor } = storeToRefs(adminStore)

const { colorsStyle, isAlt } = useColors(loggedIn, idzPrimaryColor, idzSecondaryColor)

const { locale: i18nLocal } = useI18n()

watch(loggedIn, () => {
  if (!loggedIn.value) {
    websocketHandler.handleCloseEvent()
    router.push({ name: 'login' })
  } else {
    websocketHandler.handleCreateEvent()
    router.push({ name: 'index' })
  }
})

onMounted(async () => {
  await iAdvizeStore.initClient()
  if (loggedIn.value) {
    configStore.setIntegrationPrimaryColor(
      idzPrimaryColor.value || companyColor.value || COLORS.blue['5']
    )
    configStore.setIntegrationSecondaryColor(
      idzSecondaryColor.value || companyColor.value || COLORS.blue['3']
    )
  }
})

onUnmounted(() => {
  websocketHandler.handleCloseEvent()
})

watch(locale, (newValue) => {
  i18nLocal.value = newValue
})
</script>
